import React, { useCallback, useEffect } from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import useLocalStorage from 'react-localstorage-hook';

export const ClaimExitedTab = () => {
  const [, setShouldPublish] = useLocalStorage('shouldPublishClaimExited', false);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClaimExitedButtonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      setShouldPublish(true);
    },
    [setShouldPublish],
  );

  return (
    <Accordion id="claimExitedTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>claimExited</Typography>
        <Button
          id="publish-claim-exited"
          fullWidth
          onClick={handleClaimExitedButtonClick}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails />
    </Accordion>
  );
};
